
import { useMemo, useState } from 'react';
import "./UploadSchedule.css"
import useContacts from '../../../../../hooks/useContacts';
import useCustomSchedule from '../../../../../hooks/useCustomSchedule';
import { showToastMessage } from '../../../../../../../utils/commonFunctions';
import { CircularProgress } from '@mui/material';
import CustomToolTip from '../../../../../../CommonComponents/CustomToolTip';

const UploadSchedule = () => {
    const {customScheduleModalData, setCustomScheduleModalData} = useCustomSchedule()
    const isModalOpen = useMemo(() => customScheduleModalData?.scheduleType === "Import",[customScheduleModalData?.scheduleType])
    const { import_schedule } = useContacts()
    const [selectedFile, setSelectedFile] = useState<any | null>(null);
    const [selectedDropFile, setSelectedDropFile] = useState<File | null>(null);
    const [importing, setImporting] = useState(false);

    const closeModal = () => {
        setCustomScheduleModalData(null)
        setSelectedFile(null);
        setSelectedDropFile(null);
    };

    const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            if (!file.name.toLowerCase().endsWith('.json')) {
                showToastMessage('error', 'Only JSON files are supported');
                event.target.value = '';
                return;
            }
            const reader = new FileReader();
            reader.onload = (e: any) => {
                const uploadFile = e.target.result;
                // Do something with the file content
                const blob = new Blob([uploadFile], { type: "multipart/form-data" });
                const file_data = new FormData();
                file_data.append("file", blob, file.name);

                setSelectedFile({
                    file_data: file_data!,
                    name: file.name,
                    displayName: file.name,
                })
                setSelectedDropFile(null)

            };
            reader.readAsText(file);
        }
    };

    const handleDrop = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
        const file = event.dataTransfer.files?.[0];
        if (file) {
            if (!file.name.toLowerCase().endsWith('.json')) {
                showToastMessage('error', 'Only JSON files are supported');
                return;
            }
            setSelectedDropFile(file);
            setSelectedFile(null);
        }
    };

    const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
        event.preventDefault();
    };

    const handleImport = () => {
        const fileToUpload = selectedFile || selectedDropFile;
        if (fileToUpload) {
            setImporting(true);
            import_schedule(fileToUpload?.file_data, fileToUpload?.name)
            .then((result) => {
                showToastMessage('success', 'Schedule generated')
            })
            .catch((error) => {
                console.error('Schedule generation failed:', error);
                showToastMessage('error', error?.response?.data)
            })
            .finally(()=>{
                setImporting(false);
                closeModal()
            });
        }
    };

    return (
        <>
            {isModalOpen && (
                <div className="upload-modal-overlay" onClick={closeModal}>
                    <div
                        className="upload-modal-container"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="upload-modal-header">
                            <h2>Import Schedule</h2>
                            <button className="upload-modal-close" onClick={closeModal}>
                                &times;
                            </button>
                        </div>

                        <div className="upload-modal-content">
                            {/* Drag & Drop Zone */}
                                
                            <div
                                className="upload-drop-zone"
                                onDrop={handleDrop}
                                onDragOver={handleDragOver}
                            >
                                {selectedDropFile ? (
                                    <CustomToolTip title={selectedDropFile.name} placement="top" className="upload-file-name-tooltip">
                                        <span className="upload-file-name">{selectedDropFile.name}</span>
                                    </CustomToolTip>
                                ) : (
                                    <>
                                        Drag & Drop file here
                                        <p className="upload-supported-files">Supported: JSON</p>
                                    </>
                                )}
                            </div>

                            {/* Select from Device */}
                            <label className="upload-device-zone">
                                {selectedFile ? (
                                    <CustomToolTip title={selectedFile.displayName} placement="top" className="upload-file-name-tooltip">
                                        <span className="upload-file-name">{selectedFile.displayName}</span>
                                    </CustomToolTip>
                                ) : (
                                    <>
                                        Select from Device
                                        <p className="upload-supported-files">Supported: JSON</p>
                                    </>
                                )}
                                <input
                                    type="file"
                                    accept=".json"
                                    style={{ display: "none" }}
                                    onChange={handleFileSelect}
                                />
                            </label>
                        </div>

                        <div className="upload-modal-footer">
                            <button className="upload-cancel-btn" onClick={closeModal}>
                                Cancel
                            </button>
                            <button
                                className="upload-import-btn"
                                onClick={handleImport}
                                disabled={(!selectedFile && !selectedDropFile) || importing}
                            >
                                {importing ? (
                                    <div className='d-flex align-items-center gap-2 justify-content-center'>
                                        <CircularProgress color='inherit' size={12} />
                                        Importing...
                                    </div>
                                ) : (
                                    'Import'
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default UploadSchedule